import Vue from 'vue'
import VueRouter from 'vue-router'

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routers = [{
  path: "/redirect",
  component: () => import("@/pages/de"),
  hidden: true,
  children: [
    {
      path: "/redirect/:path(.*)",
      component: () => import("@/pages/redirect"),
    },
  ],
},
{
  path: "/",
  name: "/",
  meta: {
    affix: true
  },
  component: () => import("@/pages/index"),
} ,{
    path: "/Biao",
    name: "Biao",
    meta: {
      affix: true
    },
    component: () => import("@/pages/biao"),
  } ,{
    path: "/Niao",
    name: "Niao",
    meta: {
      affix: true
    },
    component: () => import("@/pages/niao"),
  } ,{
    path: "/Share",
    name: "Share",
    meta: {
      affix: true
    },
    component: () => import("@/pages/share"),
  }

]


const router = new VueRouter({
  mode: 'hash',
  routes: routers
})

let oneRun = true;
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
    window.document.title = to.meta.title
  }
  if (oneRun && !Vue.prototype.$store.routers) {
    oneRun = false;
    let index = router.options.routes.findIndex((d) => {
      return d.path == "/Index";
    });
    let rrr = router.options.routes;
    rrr.push({
      path: "/404",
      name: "404",
      meta: {
        title: "页面找不到了",
      },
      component: () => import("@/pages/404"),
    }, {
      path: '*',
      redirect: {
        name: "404"
      }
    })
    router.options.routes = rrr;
    //动态添加路由
    rrr.forEach((res) => {
      router.addRoute(res);
    });
    Vue.prototype.$store.commit("setRouters", rrr);
    if (!(to.path == "/" || to.path == "/Index") && !sessionStorage.getItem('FromIndex')) {
      next({ path: '/', replace: true });
      return;
    }
    if (!Vue.prototype.$storageUtil.getAuthorityToken() &&
      !(to.path == "/" || to.path == "/Index")) {
      next({ path: '/', replace: true });
      return;
    }
    // next({ ...to })的目的,是保证路由添加完了再进入页面 (可以理解为重进一次)
    // 重进一次, 不保留重复历史
    next({
      ...to,
      replace: true
    })
  } else {
    // if (to.meta.title) {
    //   document.title = to.meta.title
    // }
    if (!(to.path == "/" || to.path == "/Index") && !sessionStorage.getItem('FromIndex')) {
      next({ path: '/', replace: true });
      return;
    }
    if (!Vue.prototype.$storageUtil.getAuthorityToken() &&
      !(to.path == "/" || to.path == "/Index")) {
      next({ path: '/', replace: true });
      return;
    }
    next();
  }
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js